module.exports = __webpack_public_path__ + "components/flag/static/square/al-bee61ec355cbac20be9020dd068d5c35.svg";